export default {
  SET_SNACKBAR(state, value) {
    state.open = value.open;
    state.color = value.color;
    state.text = value.text;
    state.timeout = value.timeout;
  }
};
